import { metricsAPI } from "./api";

export const getCommonResidents = async () => {
  try {
    const res = await metricsAPI.getCommonResidents();
    return res?.data || [];
  } catch (e) {}
};

export const getProjectHeads = async () => {
  try {
    const res = await metricsAPI.getProjectHeads();
    return res?.data || [];
  } catch (e) {}
};

export const getProjectSectionForemen = async () => {
  try {
    const res = await metricsAPI.getProjectSectionForemen();
    return res?.data || [];
  } catch (e) {}
};

export const metricTitles = {
  OKK: "ДКК",
  TECHNADZOR: "ДТН",
  PROVIDER_REQUEST: "Заявки поставщику",
  AVR: "Акт выполненных работ",
  PAYMENT: "Платежи",
  AGREEMENT: "Договоры",
  WORK_PAYMENT: "Объем выполненных работ",
};
export const getMetrics = async (params) => {
  try {
    const res = await metricsAPI.getMetrics(params);
    const data =
      res?.data?.map((item) => ({
        ...item,
        label: metricTitles[item.metric_code],
      })) || [];
    return {
      project_date_percent: res?.project_date_percent,
      data: data?.filter((item) => item?.data),
    };
  } catch (e) {}
};

export const getMetricData = async (params) => {
  try {
    const res = await metricsAPI.getMetricData(params);

    const firstEl = res?.data[0] || {};
    if (!firstEl) return { data: [], columns: [] };

    return {
      data: res?.data || [],
      columns: firstEl
        ? Object.keys(firstEl).map((key) => ({
            name: key,
            field: key,
            label: key,
            align: "сenter",
          }))
        : [],
    };
  } catch (e) {}
};

export const metricLabels = {
  ON_TIME: "Принято вовремя",
  ON_TIME_NOT_ACCEPTED: "Сдано, но не проверено",
  OVERDUE_ACCEPTED: "Принято с опозданием",
  OVERDUE_NOT_ACCEPTED: "Приёмка просрочена",
  OVERDUE_PAYED: "Оплачено с опозданием",
  ON_TIME_NOT_PAYED: "Ожидает оплату",
  OVERDUE_NOT_PAYED: "Оплата просрочена",
  OVERDUE_SHIPPED: "Отгружено с опозданием",
  OVERDUE_NOT_SHIPPED: "Поставка просрочена",
  ON_TIME_NOT_SHIPPED: "Ожидает отгрузку",
  OVERDUE_SIGNED: "Подписано с опозданием",
  OVERDUE_NOT_SIGNED: "Подписание просрочено",
  ON_TIME_NOT_SIGNED: "Ожидает подписи",
  CHECKED_READY: "Выполнено и проверено",
  NOT_READY: "Не выполнено",
  NOT_CHECKED_READY: "Выполнено, ожидает проверки",
};

export const getOnTimeMetricLabel = (code) => {
  if (code === "OKK") return "Принято вовремя";
  if (code === "TECHNADZOR") return "Принято вовремя";
  if (code === "PROVIDER_REQUEST") return "Отгружено вовремя";
  if (code === "AVR") return "Подписано вовремя";
  if (code === "PAYMENT") return "Оплачено вовремя";
  if (code === "AGREEMENT") return "Подписано вовремя";
  return "Принято вовремя";
};
